import React from "react"
import styled from "styled-components"
import { SectionWrapper } from "../../components/common/wrappers/Wrappers"
import {
  SectionTitle,
  SectionText,
} from "../../components/common/typography/Typography"
const OpenTimeSection = ({ open_time }) => {
  return (
    <Wrapper>
      <SectionWrapper paddingSm="30px 20px" paddingXl="40px 100px">
        <SectionTitle>Open Time</SectionTitle>
        {open_time && (
          <OpenTimeWrapper>
            {open_time.map((item, index) => {
              return <SectionText key={index}>{item}</SectionText>
            })}
          </OpenTimeWrapper>
        )}
      </SectionWrapper>
    </Wrapper>
  )
}

export default OpenTimeSection

const Wrapper = styled.div``

const OpenTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 5px;
  margin-bottom: 30px;
`
